<template>
  <div class="cart">
    <!--    购物车头部-->
    <div class="cart-header">
      <i></i>
      <span class="cart-title">{{ computedCartText }}</span>
      <span class="cart-num">({{ shopCarNumber }})</span>
    </div>
    <!--购物车商品部分-->
    <div class="cart-card">
      <div class="cartCard-wrapper">
        <template v-if="vueAppTypeName === ''">
          <div v-for="cardItem in shopCardList" :key="cardItem.storeId">
            <div class="card-title">
              <div class="cardTitle-left">
                <i
                  :class="[{ active: selectedStores[cardItem.storeId] }]"
                  @click.prevent="toggleStoreSelection(cardItem.storeId)"
                ></i>
                <img :src="cardItem.storeLogo" alt />
                <span>{{ cardItem.storeName }}</span>
              </div>
              <div class="choose-buy">
                ¥{{ Math.floor(cardItem.selectedTotalPrice * 100) / 100 || 0 }}
              </div>
            </div>
            <a class="sales-card" v-for="salesitem in cardItem.shopCarList" :key="salesitem.id">
              <div class="checkbox-container">
                <i
                  class="rounded-icon"
                  :class="[selectedItems[salesitem.storeCartId] ? 'active' : '']"
                  @click.prevent.stop="toggleItemSelection(salesitem.storeCartId)"
                ></i>
              </div>
              <div class="product-image-container">
                <img :src="salesitem.productImg" alt />
                <div class="stock-type-label">
                  {{ salesitem.stockType === 1 ? '订货' : '现货' }}
                </div>
              </div>
              <div class="sales-info">
                <p>
                  {{ salesitem.productName }}
                </p>

                <p>
                  <span>{{ salesitem.productSpec }}</span>
                </p>
                <div class="salesInfo-price">
                  <div class="price-info">
                    ¥
                    <span>{{ salesitem.productPrice }}</span>
                    <span>/</span>
                    <span>{{ salesitem.productUnit }}</span>
                  </div>

                </div>
                <!-- 数量控制组件 -->
                <QuantityControl
                  :quantity="salesitem.productNum"
                  :product-name="salesitem.productName"
                  @quantity-change="handleQuantityChange(salesitem, $event)"
                  @delete="handleProductDelete(salesitem)"
                />
              </div>
              <div class="overlay">
                <van-overlay :show="showDeletePopup" :lock-scroll="true">
                  <div class="wrapper" @click.stop>
                    <div class="block">
                      <p class="title">删除商品</p>
                      <p class="ipt">是否确认删除商品？</p>
                      <div class="confirm1" @click="delCardSales(currentDeleteItem.id)">
                        <p>确认</p>
                      </div>
                      <div class="cancel" @click="showDeletePopup = false">取消</div>
                    </div>
                  </div>
                </van-overlay>
              </div>
            </a>

            <!-- 只显示最优优惠信息 -->
            <div class="discount-info" v-if="getStoreBestDiscount(cardItem)">
              <span class="discount-text">
                {{ getStoreBestDiscount(cardItem).description }}
              </span>
              <span class="discount-save">
                优惠 ¥{{ getStoreBestDiscount(cardItem).discountAmount.toFixed(2) }}，
                折后 ¥{{ getStoreBestDiscount(cardItem).finalAmount.toFixed(2) }}
              </span>
            </div>
          </div>
        </template>

        <template v-if="vueAppTypeName !== ''">
          <div v-for="cardItem in shopCardList" :key="cardItem.storeId">
            <div class="card-title">
              <div class="cardTitle-left">
                <img :src="cardItem.storeLogo" alt />
                <span>{{ cardItem.storeName }}</span>
              </div>
            </div>
            <ProductList :salesList="cardItem.shopCarList" @remove-from-cart="delCardSales" />
          </div>
        </template>
      </div>
    </div>
    <!--    底部提交订单-->
    <div class="submit-sales" v-if="vueAppTypeName === ''">
      <div class="select-all-container">
        <i :class="[isAllSelected ? 'active' : '']" @click.prevent="toggleSelectAll"></i>
        <span :class="[isAllSelected ? 'active' : '']" @click="toggleSelectAll">全选</span>
      </div>
      <div class="space-info">
        <span class="total-price">合计: ¥{{ selectedSummary.price }}</span>
      </div>
      <div class="actions">
        <button @click="submitOrder">提交订单({{ selectedSummary.count }})</button>
      </div>
    </div>

    <!--    再逛逛图标-->
    <i class="again-look" tag="div" @click.prevent="viewBooth">再逛逛</i>
    <!--    修改商品数量-->
    <van-popup v-model="show">
      <div class="wrapper">
        <div class="block">
          <h1>修改数量</h1>
          <input
            type="number"
            oninput="if(value.length>4)value=value.slice(0,4)"
            v-model="salesNum"
            placeholder="请输入数量"
            @focus="selectAll"
          />
          <button @click="showUpdate(1)">确认</button>
          <span @click="showUpdate">取消</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import storeCartApi from '@/api/v3/storeCart';
import QuantityControl from '@/components/QuantityControl/QuantityControl.vue';

export default {
  components: {
    ProductList: () => import('../../components/ProductList/ProductList'),
    QuantityControl,
  },
  data() {
    return {
      vueAppTypeName: process.env.VUE_APP_TYPE_NAME || '',
      showDeletePopup: false,
      show: false,
      //购物车列表
      shopCardList: [],
      //选择状态管理
      selectedStores: {}, // 店铺选择状态
      selectedItems: {}, // 商品选择状态
      //选择的价格
      chooseSalesPrice: 0,
      //要修改数量的商品
      updateSalesNum: {},
      //修改的商品数量
      salesNum: 0,
      //爱窝数量
      shopCarNumber: 0,
      //记录商铺id的数组
      idArr: [],
      //当前要删除的商品
      currentDeleteItem: null,
    };
  },
  methods: {
    ...mapActions(['setIsCart', 'setStoreId']),

    // 将优惠券信息转换为折扣信息
    convertCouponsToDiscounts(coupons) {
      return coupons.map(coupon => {
        const discount = {
          discountType: 2, // 默认为金额满减
          moneyRequirement: coupon.minOrderAmount,
          numberRequirement: coupon.perUnitQuantity || 0,
          discountDiscount: 10, // 默认无折扣
          couponId: coupon.couponId,
          couponName: coupon.couponName,
          couponType: coupon.couponType
        };

        // 根据优惠券类型转换
        switch (coupon.couponType) {
          case 0: // 满减券
            discount.discountType = 2;
            discount.moneyRequirement = coupon.minOrderAmount;
            break;
          case 1: // 折扣券
            discount.discountType = 2;
            discount.moneyRequirement = coupon.minOrderAmount;
            discount.discountDiscount = coupon.amount; // 折扣比例
            break;
          case 3: // 每满减券
            discount.discountType = 2;
            discount.moneyRequirement = coupon.minOrderAmount;
            break;
          case 4: // 件数满减券
            discount.discountType = 1;
            discount.numberRequirement = coupon.perUnitQuantity;
            break;
        }

        return discount;
      });
    },

    // 获取所有购物车商品
    getAllCartItems() {
      const allItems = [];
      this.shopCardList.forEach(store => {
        store.shopCarList.forEach(item => {
          allItems.push(item);
        });
      });
      return allItems;
    },

    // 计算店铺的最优优惠
    getStoreBestDiscount(store) {
      const selectedStoreItems = store.shopCarList.filter(item => this.selectedItems[item.storeCartId]);

      if (selectedStoreItems.length === 0 || !(store.availableCoupons && store.availableCoupons.length)) {
        return null;
      }

      const totalAmount = selectedStoreItems.reduce((sum, item) => sum + item.productTotalPrice, 0);
      const totalQuantity = selectedStoreItems.reduce((sum, item) => sum + item.productNum, 0);

      let bestDiscount = {
        coupon: null,
        discountAmount: 0,
        finalAmount: totalAmount,
        description: '',
      };

      store.availableCoupons.forEach(coupon => {
        if (!coupon.isActive) return;

        let discountAmount = 0;
        let description = '';

        switch (coupon.couponType) {
          case 0: // 满减券
            if (totalAmount >= coupon.minOrderAmount) {
              discountAmount = coupon.amount;
              description = '满' + coupon.minOrderAmount + '元减' + coupon.amount + '元';
            }
            break;

          case 1: // 折扣券
            if (totalAmount >= coupon.minOrderAmount) {
              const discountRate = coupon.amount / 100;
              discountAmount = totalAmount * (1 - discountRate);
              if (coupon.maxDiscountAmount && discountAmount > coupon.maxDiscountAmount) {
                discountAmount = coupon.maxDiscountAmount;
              }
              description = '满' + coupon.minOrderAmount + '元享' + coupon.amount + '折';
            }
            break;

          case 3: // 每满减券
            if (totalAmount >= coupon.minOrderAmount) {
              const times = Math.floor(totalAmount / coupon.minOrderAmount);
              discountAmount = times * coupon.amount;
              if (coupon.maxDiscountAmount && discountAmount > coupon.maxDiscountAmount) {
                discountAmount = coupon.maxDiscountAmount;
              }
              description = '每满' + coupon.minOrderAmount + '元减' + coupon.amount + '元';
            }
            break;

          case 4: // 件数券
            if (totalQuantity >= coupon.perUnitQuantity) {
              const times = Math.floor(totalQuantity / coupon.perUnitQuantity);
              discountAmount = times * coupon.amount;
              if (coupon.maxDiscountAmount && discountAmount > coupon.maxDiscountAmount) {
                discountAmount = coupon.maxDiscountAmount;
              }
              description = '每满' + coupon.perUnitQuantity + '件减' + coupon.amount + '元';
            }
            break;
        }

        if (discountAmount > bestDiscount.discountAmount) {
          bestDiscount = {
            coupon,
            discountAmount,
            finalAmount: totalAmount - discountAmount,
            description,
          };
        }
      });

      return bestDiscount.discountAmount > 0 ? bestDiscount : null;
    },

    // 全选/取消全选
    toggleSelectAll() {
      const shouldSelectAll = !this.isAllSelected;

      this.getAllCartItems().forEach(item => {
        this.$set(this.selectedItems, item.storeCartId, shouldSelectAll);
      });

      // 同步店铺选择状态
      this.shopCardList.forEach(store => {
        const allSelected = store.shopCarList.every(item => this.selectedItems[item.storeCartId]);
        this.$set(this.selectedStores, store.storeId, allSelected);
      });

      this.updateSelectedPrices();
    },

    // 店铺选择
    toggleStoreSelection(storeId) {
      const store = this.shopCardList.find(s => s.storeId === storeId);
      const shouldSelect = !this.selectedStores[storeId];

      this.$set(this.selectedStores, storeId, shouldSelect);
      store.shopCarList.forEach(item => {
        this.$set(this.selectedItems, item.storeCartId, shouldSelect);
      });

      this.updateSelectedPrices();
    },

    // 商品选择
    toggleItemSelection(storeCartId) {
      this.$set(this.selectedItems, storeCartId, !this.selectedItems[storeCartId]);

      // 更新对应店铺的选择状态
      const item = this.getAllCartItems().find(i => i.storeCartId === storeCartId);
      if (item) {
        const store = this.shopCardList.find(s => s.storeId === item.storeId);
        const allSelected = store.shopCarList.every(i => this.selectedItems[i.storeCartId]);
        this.$set(this.selectedStores, item.storeId, allSelected);
      }

      this.updateSelectedPrices();
    },

    // 更新选中商品的价格
    updateSelectedPrices() {
      this.shopCardList.forEach(store => {
        store.selectedTotalPrice = 0;
        store.shopCarList.forEach(item => {
          if (this.selectedItems[item.storeCartId]) {
            store.selectedTotalPrice += item.productPrice * item.productNum;
          }
        });

        // 计算最优优惠
        const bestDiscount = this.getStoreBestDiscount(store);
        if (bestDiscount) {
          store.bestDiscount = bestDiscount.discountAmount;
          store.discountPrice = bestDiscount.finalAmount;
        } else {
          store.bestDiscount = 0;
          store.discountPrice = store.selectedTotalPrice;
        }
      });

      this.chooseSalesPrice = this.selectedSummary.price;
    },

    // 初始化选择状态
    initializeSelectionState() {
      // 清空现有选择状态
      this.selectedStores = {};
      this.selectedItems = {};

      // 初始化所有商品为未选中状态
      this.shopCardList.forEach(store => {
        this.$set(this.selectedStores, store.storeId, false);
        store.shopCarList.forEach(item => {
          this.$set(this.selectedItems, item.storeCartId, false);
        });
      });
    },

    //展示修改数量框
    selectAll(event) {
      event.target.select(); // 选中文本框中的所有内容
    },
    showUpdate(value) {
      this.show = !this.show;
      //保存修改的产品
      if (typeof value === 'object' && 'storeId' in value) {
        this.updateSalesNum = value;
        this.salesNum = value.productNum;
      }
      //确认修改
      if (value === 1) {
        // 找到要修改的商品
        let targetItem = null;
        for (let i = 0; i < this.shopCardList.length; i++) {
          const storeItem = this.shopCardList[i];
          if (storeItem.storeId === this.updateSalesNum.storeId) {
            for (let j = 0; j < storeItem.shopCarList.length; j++) {
              const item = storeItem.shopCarList[j];
              if (
                item.productId === this.updateSalesNum.productId &&
                item.id === this.updateSalesNum.id
              ) {
                targetItem = item;
                break;
              }
            }
            break;
          }
        }

        if (targetItem) {
          const oldNum = targetItem.productNum;
          const newNum = this.salesNum;

          // 使用async/await处理API调用
          this.updateItemQuantity(targetItem, oldNum, newNum);
        }
      }
    },

    // 更新单个商品数量的辅助方法
    async updateItemQuantity(item, oldNum, newNum) {
      try {
        // 计算数量差值并调用相应的API
        if (newNum > oldNum) {
          await storeCartApi.increaseQuantity({
            storeCartId: item.id,
            quantity: newNum - oldNum
          });
        } else if (newNum < oldNum) {
          await storeCartApi.decreaseQuantity({
            storeCartId: item.id,
            quantity: oldNum - newNum
          });
        }
        item.productNum = newNum;
        item.productTotalPrice = item.productPrice * newNum;
        this.updateSelectedPrices();
        this.$toast('修改成功');
      } catch (error) {
        console.error('修改数量失败:', error);
        this.$toast('修改失败');
      }
    },

    //获取商品列表
    async getShopCardNum() {
      try {
        const data = await storeCartApi.list();
        if (data && Array.isArray(data)) {
          // 转换新的数据结构到旧的格式
          this.shopCardList = data.map(storeGroup => ({
            storeId: storeGroup.storeId,
            storeName: storeGroup.storeName,
            storeLogo: storeGroup.storeIcon,
            choose: false,
            selectedTotalPrice: 0,
            bestDiscount: 10,
            discountPrice: 0,
            totalQuantity: storeGroup.totalQuantity,
            totalPrice: storeGroup.totalPrice,
            availableCoupons: storeGroup.availableCoupons || [],
            discountList: this.convertCouponsToDiscounts(storeGroup.availableCoupons || []),
            shopCarList: storeGroup.cartItems.map(item => ({
              id: item.storeCartId,
              storeCartId: item.storeCartId,
              storeId: item.storeId,
              productId: item.productId,
              productCode: item.productCode,
              productName: item.productName,
              productSpec: item.productSpec,
              productUnit: item.productUnit,
              productImg: item.productCover,
              productPrice: item.productPrice,
              productCostPrice: item.productCostPrice,
              productNum: item.productNum,
              productTotalPrice: item.productTotalPrice,
              choose: false,
              status: item.status,
              remark: item.remark,
              createTime: item.createTime,
              updateTime: item.updateTime,
              stockType: item.stockType || 0 // 添加库存类型字段
            }))
          }));

          // 计算购物车总数量
          this.shopCarNumber = data.reduce((total, store) => total + store.totalQuantity, 0);

          // 初始化选择状态
          this.initializeSelectionState();
          this.updateSelectedPrices();

          console.log('转换后的数据', this.shopCardList);
          console.log('购物车总数量', this.shopCarNumber);
        } else {
          this.shopCardList = [];
          this.shopCarNumber = 0;
        }
      } catch (error) {
        console.error('获取购物车列表失败:', error);
        this.shopCardList = [];
        this.shopCarNumber = 0;
      }
    },

    async viewBooth() {
      let path = '/product/list';
      let storeId = null;

      // 获取cartItems中createTime最新的条目的storeId
      if (this.shopCarNumber > 0 && this.shopCardList.length > 0) {
        let latestItem = null;
        let latestTime = null;

        // 遍历所有店铺的所有商品，找到createTime最新的商品
        this.shopCardList.forEach(store => {
          store.shopCarList.forEach(item => {
            if (item.createTime) {
              const itemTime = new Date(item.createTime).getTime();
              if (!latestTime || itemTime > latestTime) {
                latestTime = itemTime;
                latestItem = item;
              }
            }
          });
        });

        if (latestItem) {
          storeId = latestItem.storeId;
        } else {
          // 如果没有createTime，则使用第一个店铺的ID
          storeId = this.shopCardList[0].storeId;
        }
      }

      // 如果没有购物车数据，尝试从localStorage获取
      if (!storeId) {
        const viewStoreId = localStorage.getItem('viewStoreId');
        if (viewStoreId && viewStoreId !== 'null') {
          storeId = JSON.parse(viewStoreId);
        }
      }

      // 如果还是没有storeId，使用默认值或显示提示
      if (!storeId) {
        this.$toast('无法确定店铺信息');
        return;
      }

      this.$router.push({
        path: path,
        query: { storeId: storeId },
      });
    },

    //增加或减少数量
    async addBtn(type, value) {
      try {
        if (type === 'sub') {
          if (value.productNum <= 1) return;
          await storeCartApi.decreaseQuantity({
            storeCartId: value.id || value.storeCartId,
            quantity: 1
          });
          value.productNum--;
          value.productTotalPrice = value.productPrice * value.productNum;
        }
        if (type === 'add') {
          if (value.productNum >= 9999) return;
          await storeCartApi.increaseQuantity({
            storeCartId: value.id || value.storeCartId,
            quantity: 1
          });
          value.productNum++;
          value.productTotalPrice = value.productPrice * value.productNum;
        }

        // 更新选中商品的价格
        this.updateSelectedPrices();
        this.$toast('修改成功');
      } catch (error) {
        console.error('修改数量失败:', error);
        this.$toast('修改失败');
      }
    },
    //修改购物车产品数量到数据库
    async updateCardNum(num, shopCarId) {
      try {
        // 由于v3 API没有直接修改数量的接口，我们需要计算差值并调用增加/减少接口
        // 这里暂时保留原逻辑，但在实际使用中建议通过addBtn方法来处理
        this.$toast('请使用+/-按钮修改数量');
      } catch (error) {
        console.error('修改数量失败:', error);
        this.$toast('修改失败');
      }
    },
    async handleShowDeletePopup(salesitem) {
      this.currentDeleteItem = salesitem;
      this.showDeletePopup = true;
    },
    //删除购物车的产品
    async delCardSales(shopCarIds) {
      try {
        // 支持单个ID或逗号分隔的多个ID
        const ids = typeof shopCarIds === 'string' ? shopCarIds.split(',') : [shopCarIds];

        // 批量删除
        const deletePromises = ids.map(id => storeCartApi.delete(parseInt(id.trim())));
        await Promise.all(deletePromises);

        this.showDeletePopup = false;
        this.$toast('删除成功');
        await this.getShopCardNum();
      } catch (error) {
        console.error('删除购物车商品失败:', error);
        this.showDeletePopup = false;
        this.$toast('删除失败');
      }
    },
    //继续选购
    async continueBuy(storeId) {
      this.setIsCart(0);
      let { data } = await this.$http.aPost(this.$api.getHomePageStore, {
        storeId,
      });
      if (data.code === 0) {
        let path =
          data.storeHomePage.storeIdentity === 2
            ? '/AdvertisingBooth'
            : data.storeHomePage.storeIdentity === 1
            ? '/userBooth'
            : '';
        await this.$router.push({ path: path, query: { storeId } });
      }
    },
    //提交订单
    async submitOrder() {
      try {
        // 获取所有选中的商品
        const selectedItems = this.getAllCartItems().filter(item => this.selectedItems[item.storeCartId]);

        // 检查是否选择了商品
        if (selectedItems.length === 0) {
          this.$toast('请先选择商品');
          return;
        }

        // 检查是否来自同一个店铺
        const storeIds = selectedItems.map(item => item.storeId);
        const uniqueStores = storeIds.filter((storeId, index) => storeIds.indexOf(storeId) === index);
        if (uniqueStores.length > 1) {
          this.$toast('请选择单个商铺的商品');
          return;
        }

        // 检查库存类型一致性：只能提交一种stockType类型的商品
        const stockTypes = selectedItems.map(item => item.stockType).filter(type => type !== null && type !== undefined);
        const uniqueStockTypes = [...new Set(stockTypes)];
        
        if (uniqueStockTypes.length > 1) {
          this.$toast('订单中只能包含相同库存类型的商品，请分别提交现货订单和订货订单');
          return;
        }
        
        if (uniqueStockTypes.length === 0) {
          this.$toast('无法确定商品库存类型，请重试');
          return;
        }

        // 准备订单数据
        const orderPreview = {
          selectedItems: selectedItems,
          originalTotal: Number(this.selectedSummary.price) || 0,
          finalTotal: Number(this.selectedSummary.price) || 0
        };

        // 获取优惠券信息
        const availableCoupons = [];
        if (this.shopCardList.length > 0) {
          const storeData = this.shopCardList.find(store => store.storeId === uniqueStores[0]);
          if (storeData && storeData.availableCoupons) {
            availableCoupons.push(...storeData.availableCoupons);
          }
        }

        // 准备传递给checkout页面的数据
        const checkoutData = {
          orderPreview,
          availableCoupons
        };

        // 将订单数据存储到store中
        await this.$store.dispatch('setOrderData', checkoutData);

        // 跳转到订单确认页面（不再通过URL传递数据）
        await this.$router.push({
          path: '/order/checkout'
        });
      } catch (error) {
        console.error('跳转订单确认页面失败:', error);
        this.$toast('跳转失败，请重试');
      } finally {
        this.idArr = [];
      }
    },

    // 处理数量变化
    async handleQuantityChange(item, newQuantity) {
      try {
        // 使用现有API更新数量
        const oldQuantity = item.productNum;
        if (newQuantity > oldQuantity) {
          // 增加数量
          await storeCartApi.increaseQuantity({
            storeCartId: item.id || item.storeCartId,
            quantity: newQuantity - oldQuantity
          });
        } else if (newQuantity < oldQuantity) {
          // 减少数量
          await storeCartApi.decreaseQuantity({
            storeCartId: item.id || item.storeCartId,
            quantity: oldQuantity - newQuantity
          });
        }

        // 更新本地数据
        item.productNum = newQuantity;
        item.productTotalPrice = item.productPrice * newQuantity;

        // 更新选中商品的价格
        this.updateSelectedPrices();
        this.$toast('修改成功');
      } catch (error) {
        console.error('修改数量失败:', error);
        this.$toast('修改失败');
      }
    },

    // 处理商品删除
    async handleProductDelete(item) {
      try {
        await storeCartApi.delete(item.id || item.storeCartId);
        this.$toast('删除成功');
        await this.getShopCardNum();
      } catch (error) {
        console.error('删除购物车商品失败:', error);
        this.$toast('删除失败');
      }
    },
  },
  computed: {
    computedCartText() {
      if (this.vueAppTypeName !== '') {
        return '收藏';
      }
              return '购物车';
    },
    bmTab() {
      return this.$store.state.bmTab;
    },
    getStoreId() {
      return this.$route.query.storeId || sessionStorage.getItem('storeId');
    },

    // 全选状态
    isAllSelected() {
      const allItems = this.getAllCartItems();
      if (allItems.length === 0) return false;
      return allItems.every(item => this.selectedItems[item.storeCartId]);
    },

    // 选中商品的总数和总价
    selectedSummary() {
      let totalCount = 0;
      let totalPrice = 0;

      const allItems = this.getAllCartItems();
      allItems.forEach(item => {
        if (this.selectedItems[item.storeCartId]) {
          totalCount += Number(item.productNum) || 0;
          totalPrice += Number(item.productTotalPrice) || 0;
        }
      });

      return {
        count: totalCount,
        price: totalPrice.toFixed(2),
      };
    },
  },
  created() {
    this.setStoreId(JSON.parse(localStorage.getItem('storeId')));
    this.$store.state.bmTab = 2;
    this.getShopCardNum();
  },
  mounted() {
    // this.aboutValuda();
  },
};
</script>

<style lang="scss">
@import '../../assets/mixin';

.cart {
  width: 100%;
  height: 95%;
  background: $bgcolor;
  margin-top: 2px;
  //头部
  .cart-header {
    width: 100%;
    height: 86px;
    padding: 30px 0 16px 32px;
    background-color: #ffffff;
    position: fixed;
    top: 54px;
    left: 0;

    i {
      display: inline-block;
      width: 40px;
      height: 40px;
      background: url('../../assets/img/cart/cart.png') center center no-repeat;
      background-size: contain;
      vertical-align: -6px;
      margin-right: 16px;
    }

    span {
      display: inline-block;
      font-size: 34px;
      color: #dc6a2b;
      line-height: 34px;
      font-weight: bold;
    }
  }

  //购物车商品部分
  .cart-card {
    width: 100%;
    height: calc(100% - 142px - 196px);
    padding: 32px 24px;
    overflow: auto;
    position: fixed;
    bottom: 196px;
    left: 0;

    .cartCard-wrapper {
      width: 100%;
      background-color: $bgcolor;

      & > div {
        width: 100%;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        margin-bottom: 32px;
        background-color: #ffffff;
        padding: 0 16px;
        //购物车商品头部
        .card-title {
          width: 100%;
          height: 104px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #dce4eb;

          .cardTitle-left {
            display: flex;
            align-items: center;

            i {
              width: 26px;
              height: 26px;
              display: inline-block;
              width: 30px;
              height: 30px;
              border: 2px solid #50cc73; // 绿色边框
              border-radius: 50%;
              @include set-background('../../assets/img/cart/null.png');
              &.active {
                @include set-background('../../assets/img/cart/true.png');
              }
            }

            img {
              width: 40px;
              height: 40px;
              margin-left: 24px;
              margin-right: 10px;
              border-radius: 50%;
            }

            span {
              font-size: 28px;
              font-weight: bold;
              color: #222222;
            }
          }

          .choose-buy {
            font-size: 28px;
            font-weight: bold;
            color: #000000;
            margin-right: 28px;
          }
        }

        //购物车商品卡片
        .sales-card {
          width: 100%;
          display: flex;
          align-items: center;
          margin-top: 33px;
          background-color: #ffffff;
          padding-bottom: 33px;

          .checkbox-container {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 15px;

            .rounded-icon {
              width: 30px;
              height: 30px;
              border: 2px solid #50cc73;
              border-radius: 50%;
              background: url('../../assets/img/cart/null.png') no-repeat center;
              background-size: 60%;
              cursor: pointer;
              transition: background 0.3s, border-color 0.3s;

              &.active {
                background: url('../../assets/img/cart/true.png') no-repeat center;
                background-size: 60%;
                border-color: #2fb555;
              }
            }
          }

          .user-avatar {
            width: 40px;
            height: 40px;
            margin-left: 24px;
            margin-right: 10px;
            border-radius: 50%;
          }

          .product-image-container {
            position: relative;
            margin-left: 0;
            margin-right: 24px;

            img {
              width: 160px;
              height: 160px;
              border-radius: 10px;
              display: block;
            }

            .stock-type-label {
              position: absolute;
              bottom: 4px;
              left: 4px;
              background: rgba(0, 0, 0, 0.7);
              color: white;
              font-size: 20px;
              padding: 2px 6px;
              border-radius: 4px;
              font-weight: bold;
            }
          }

          img {
            width: 160px;
            height: 160px;
            border-radius: 10px;
            margin-left: 23px;
            margin-right: 24px;
          }

          .sales-info {
            flex: 1;
            height: 180px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            p {
              color: #222222;
              font-size: 32px;
              font-weight: bold;
              line-height: 39px;

              span {
                font-size: 28px;
                color: #999999;
                margin-left: 2px;
              }
            }

            .salesInfo-price {
              display: flex;
              justify-content: flex-start; // 保持从左排列
              align-items: center; // 垂直居中对齐
              margin-bottom: 15px;
              margin-bottom: 15px;

              .price-info {
                display: flex;
                align-items: center; // 垂直居中对齐
                gap: 10px; // 元素之间的间距

                .input-count {
                  color: #50cc73; // 字体颜色
                  border: 2px solid #50cc73; // 显示边框
                  border-radius: 10px; // 圆角
                  text-align: center; // 文本居中
                  width: 121px; // 宽度
                  height: 40px; // 高度
                  font-size: 28px; // 字体大小
                  line-height: 40px; // 行高
                  cursor: pointer; // 鼠标指针样式
                  transition: border-color 0.3s; // 边框颜色过渡

                  &:hover {
                    border-color: #2fb555; // 悬停时的边框颜色
                  }

                  &:focus {
                    outline: none; // 去掉默认的聚焦轮廓
                    border-color: #2fb555; // 聚焦时的边框颜色
                  }
                }
              }

              .checkbox-container {
                margin-right: 30px; // 控制和价格的间距
              }

              .delete-button {
                width: 40px; // 设置删除按钮的宽度
                height: 40px; // 设置删除按钮的高度
                background: url('../../assets/img/cart/del.png') center center no-repeat; // 设置删除图标
                background-size: contain; // 确保图标适应按钮
                cursor: pointer; // 鼠标指针样式
                display: inline-block; // 确保按钮可见
              }
            }

            .salesInfo-bottom {
              display: flex;
              justify-content: left; // 整体居中
              align-items: center;
              margin-top: 10px;
              gap: 25px; // 增加 checkbox、sub 和 add 之间的间隔

              .sub-button {
                width: 120px; // 增加 sub 按钮的宽度
                height: 41px;
                background: url('../../assets/img/cart/sub.png') center no-repeat;
                background-size: contain;
                cursor: pointer;
              }

              .add-button {
                width: 120px; // 增加 add 按钮的宽度
                height: 41px;
                background: url('../../assets/img/cart/add.png') center no-repeat;
                background-size: contain;
                cursor: pointer;
              }
            }
          }

          /*删除弹窗*/
          .overlay {
            .wrapper {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
              background: #222;
            }

            .block {
              width: 540px;
              background: #ffffff;
              opacity: 1;
              border-radius: 20px;

              .title {
                width: 100%;
                text-align: center;
                font-size: 32px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #000000;
                margin-top: 40px;
              }

              .ipt {
                margin-top: 48px;
                margin-left: 40px;
                width: 460px;
                height: 80px;
                opacity: 1;
                border-radius: 10px;
                padding-left: 20px;

                input {
                  width: 100%;
                  height: 100%;
                  font-size: 32px;
                  border: 1px solid #dce4eb;
                }
              }

              .join {
                margin-top: 48px;
                margin-left: 40px;
                width: 460px;
                height: 80px;
                border: 1px solid #dce4eb;
                opacity: 1;
                border-radius: 10px;
                padding-left: 20px;
                display: flex;
                font-size: 34px;
                justify-content: center;
                font-family: Source Han Sans CN;
                font-weight: bold;
              }

              .confirm1 {
                width: 460px;
                height: 80px;
                background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
                opacity: 1;
                border-radius: 40px;
                margin-top: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 32px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #ffffff;
              }

              .confirm {
                width: 460px;
                height: 80px;
                background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
                opacity: 1;
                border-radius: 40px;
                margin-top: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 32px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #ffffff;
              }

              .cancel {
                width: 100%;
                text-align: center;
                font-size: 30px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #909397;
                margin-top: 32px;
                padding-bottom: 32px;
              }
            }
          }
        }
      }
    }
  }

  .submit-sales {
    width: 100%;
    height: 96px;
    display: flex; // 使用 flexbox
    align-items: center; // 垂直居中
    background-color: #ffffff;
    position: fixed;
    bottom: 100px;
    left: 0;
    padding: 0 38px;

    .select-all-container {
      display: flex;
      align-items: center;
      margin-right: 20px;

      i {
        padding: 10px;
        display: inline-block;
        width: 30px;
        height: 30px;
        border: 2px solid #50cc73; // 绿色边框
        border-radius: 50%;
        background: url('../../assets/img/cart/null.png') no-repeat center;
        background-size: 60%;
        cursor: pointer;
        transition: background 0.3s, border-color 0.3s;

        &.active {
          background: url('../../assets/img/cart/true.png') no-repeat center;
          background-size: 60%;
          border-color: #2fb555;
        }
      }

      span {
        font-size: 18px;
        color: #333333;
        font-weight: bold;
        cursor: pointer;
        padding: 6px 12px;
        border: 2px solid #50cc73;
        border-radius: 4px;
        margin-left: 10px;
        transition: background 0.3s, color 0.3s;

        &.active {
          background-color: #50cc73;
          color: #fff;
          border-color: #2fb555;
        }
      }
    }

    .total-info {
      max-width: 100%; // 占据100% 宽度
    }

    .space-info {
      flex: 1; // 占据剩余空间的 1 部分
      max-width: 30%; // 限制最大宽度为三分之一
      color: #999999;
      font-size: 28px;
      display: flex; // 使用 flexbox
      align-items: center;
      justify-content: center; // 居中显示

      span {
        margin-right: 10px; // 添加间距
      }

      .total-price {
        font-size: 32px;
        font-weight: 600;
        color: #333;
        text-align: center;
      }
    }

    .actions {
      display: flex; // 使用 flexbox
      align-items: center; // 垂直居中
      justify-content: left; // 左对齐
      flex: 2; // 占据剩余的 2 部分

      // 按钮样式
      button {
        width: 168px;
        height: 62px;
        background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
        opacity: 1;
        border-radius: 40px;
        font-size: 30px;
        color: #ffffff;
        font-weight: 500;
        margin-left: 19px;
        border: none;
        outline: none;
        cursor: pointer;
        transition: transform 0.3s ease; // 动效

        &:hover {
          transform: scale(1.05); // 鼠标悬停时按钮略微放大
        }
      }
    }
  }

  //在逛逛按钮
  .again-look {
    width: 100px;
    height: 100px;
    background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
    border-radius: 50%;
    line-height: 100px;
    white-space: nowrap;
    text-align: center;
    color: #ffffff;
    position: fixed;
    right: 20px;
    bottom: 350px;
  }

  //遮罩层
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 540px;
    height: 440px;
    background-color: #fff;
    border-radius: 20px;
    @include flex($between, center, $column);
    padding: 40px 41px 32px 41px;

    h1 {
      color: #000000;
      line-height: 54px;
      font-weight: bold;
      font-size: 32px;
    }

    input {
      width: 460px;
      height: 80px;
      border: 1px solid #dce4eb;
      padding-left: 14px;
      font-size: 32px;

      &::placeholder {
        color: #909397;
      }
    }

    button {
      border: none;
      outline: none;
      @include hj-button(100%, 80px, 32px);
    }

    span {
      font-size: 30px;
      color: #909397;
    }
  }
}
</style>

<style scoped lang="scss">
.van-dialog {
  width: 540px;
  height: 404px;
  background-color: yellow;

  .van-dialog--round-button {
  }
}

/* 样式设置 */
.checkbox-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: 24px; /* 设置字体大小为24px */
  line-height: 24px;
  padding-left: 30px; /* 给复选框留出空间 */

  i {
    width: 30px; /* 设置宽度 */
    height: 30px; /* 设置高度 */
    border: 2px solid #50cc73; /* 绿色边框 */
    border-radius: 50%; /* 圆角 */
    background: url('../../assets/img/cart/null.png') no-repeat center; /* 默认背景 */
    background-size: 60%; /* 背景图标大小 */
    transition: background 0.3s, border-color 0.3s; /* 平滑过渡效果 */

    &.active {
      background: url('../../assets/img/cart/true.png') no-repeat center; /* 选中状态的背景图标 */
      border-color: #2fb555; /* 选中状态的边框颜色 */
    }
  }
}

.checkbox-container input[type='checkbox'] {
  opacity: 0;
  position: absolute;
}

.checkbox-container .checkmark {
  position: absolute;
  left: 0;
  top: 0;
  width: 24px; /* 设置复选框的宽度 */
  height: 24px; /* 设置复选框的高度 */
  background-color: #fff;
  border: 2px solid #ccc;
  border-radius: 3px;
  transition: background-color 0.2s, border-color 0.2s;
}

.checkbox-container input[type='checkbox']:checked + .checkmark {
  background-color: #4caf50; /* 选中时的背景色 */
  border-color: #4caf50; /* 选中时的边框色 */
}

.checkbox-container input[type='checkbox']:checked + .checkmark:after {
  content: '';
  position: absolute;
  left: 7px;
  top: 3px;
  width: 5px;
  height: 9px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.checkbox-container .checkbox-text {
  margin-left: 10px; /* 文字和复选框之间的间距 */
  font-size: 24px; /* 设置文字字号为24px */
}

.checkbox-container input[type='checkbox']:focus + .checkmark {
  box-shadow: 0 0 3px #4caf50;
}



.discount-info {
  text-align: center; /* 居中显示文字 */
  font-size: 48px; /* 字体大小增加一倍，从24px增加到48px */
}

.discount {
  font-size: 56px; /* 字体大小增加一倍，从28px增加到56px */
  color: #ff5733; /* 使用鲜艳的颜色，突出显示折扣 */
  font-weight: bold; /* 加粗字体 */
}

.discount-price {
  font-size: 56px; /* 字体大小增加一倍，从28px增加到56px */
  color: #50cc73; /* 使用绿色突出显示折后金额 */
  font-weight: bold; /* 加粗字体 */
  margin-left: 10px; /* 添加左边距，和其他文本保持间隔 */
}

// 统一所有选择框的样式
.cart i[class*='active'] {
  background: url('../../assets/img/cart/true.png') no-repeat center !important;
  background-size: 60% !important;
  border-color: #2fb555 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/cart/cart.vue